import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetExpenseTypesApi } from "../../ApiRequests";

const userData = JSON.parse(localStorage.getItem("user")) || {};
const { branchId = "" } = userData;

export const fetchExpenseTypes = createAsyncThunk(
  "fetch/ExpenseTypes",
  async () => {
    try {
      const response = await GetExpenseTypesApi(branchId);
      if (response.data?.success) {
        return response.data.data.payload;
      }
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const ExpenseTypeSlice = createSlice({
  name: "expense-types",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchExpenseTypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchExpenseTypes.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload || [];
    });
    builder.addCase(fetchExpenseTypes.rejected, (state) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default ExpenseTypeSlice.reducer;
